<template>
  <div id="app">

    <b-alert
      :show="errorDismissCountDown"
      class="position-fixed fixed-bottom shadow-lg ml-auto mr-3 border-left-danger py-3 bg-light"
      fade
      style="z-index: 2000; display: inline; width: 400px;"
      dismissible
      @dismiss-count-down="cuntDown => $store.commit('error/alertCountDownChanged', cuntDown)"
      @dismissed="$store.commit('error/clearError')">

      <div class="text-center text-danger text-lg">
        <i class="fas fa-exclamation-triangle" />
        {{ errorMessage }}
      </div>

      <b-progress variant="danger" :max="dismissSecs" :value="errorDismissCountDown" height="3px" />
    </b-alert>

    <div v-if="isLoginPage">
      <transition name="slide" mode="out-in">
        <RouterView />
      </transition>
    </div>

    <div id="wrapper" :class="{ 'toggled': toggledSidebar, 'fixed': fixedNavbar }" v-else>
      <div id="sidebar-wrapper">
        <AppSidebar />
      </div>

      <div id="content-wrapper">
        <!-- Main Content -->
        <div id="content">
          <AppTopbar />

          <div class="container-fluid">
            <transition name="fade" mode="out-in">
              <RouterView />
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppSidebar from '@/components/app/AppSidebar.vue'
import AppTopbar from '@/components/app/AppTopbar.vue'

export default {
  components: {
    AppTopbar,
    AppSidebar
  },
  computed: {
    isLoginPage () {
      return this.$route.fullPath === '/login'
    },
    toggledSidebar () {
      return this.$store.state.collapsedSidebar
    },
    fixedNavbar () {
      return this.$store.state.fixedNavbar
    },
    errorDismissCountDown () {
      return this.$store.state.error.alertCountDown
    },
    errorMessage () {
      return this.$store.state.error.haveError
    },
    dismissSecs () {
      return this.$store.state.error.defaultErrorAlertSecs
    }
  }
}
</script>

<style lang="scss">
// @import "assets/scss/main.scss";
</style>
